// extracted by mini-css-extract-plugin
module.exports = {"contextTable":"style_contextTable__2vMNQ","TableHeading":"style_TableHeading__3rvTQ","TableUL":"style_TableUL__3DG0P","TableLI":"style_TableLI__1AWVh"};